import { createFileRoute } from "@tanstack/react-router"
import { enforceSignupStep } from "@/features/registration-workflow"
import { SignupIntentionPage } from "@/pages/onboarding"

export const Route = createFileRoute("/onboarding/signup-intention")({
	beforeLoad: () => enforceSignupStep("intention"),
	component: SignupIntentionPage,
})
